import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "modification flex"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "modification flex"
};
import { ref } from 'vue';
import { ACCEPT_TYPE } from '@/const/creation';
import { env_name } from '@/util';
import { uploadObs } from 'hxhy-obs';
import { getFileType } from '@/util/uploader';
import { getStore } from '@/util/store';
import { MessagePlugin } from 'tdesign-vue-next';

/* 组件 */
import inlineEditor from '@/components/inlineEditor';

/* api */
import { applyEditExercise } from '@/api/practicePaper';

/* 变量 */

export default {
  __name: 'applyEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    exerciseId: {
      type: [Number, String],
      default: ''
    }
  },
  emits: ['update:visible', 'reload'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */
    var emit = __emit;
    var props = __props;
    var fileUrl = ref(''); // 文件地址
    var fileData = ref([]); // 文件数据
    var applyContent = ref(''); // 输入框的值
    var pushButtonLoading = ref(false); // 入库按钮的loading状态
    var userInfo = getStore({
      name: 'userInfo'
    }) || {}; // 获取userInfo

    /* 事件 */
    var handleClose = function handleClose() {
      fileUrl.value = '';
      fileData.value = [];
      applyContent.value = '';
      pushButtonLoading.value = false;
      emit('update:visible', false);
    };

    // 删除文件
    var removeFile = function removeFile() {
      fileData.value = [];
      fileUrl.value = '';
      pushButtonLoading.value = false; // 退出loading状态
    };

    // 文件获取地址
    var handleUpload = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(value) {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              pushButtonLoading.value = true; // 进入loading状态
              if (!(value.length > 0)) {
                _context.n = 4;
                break;
              }
              fileData.value = value;
              _context.p = 1;
              _context.n = 2;
              return handleUploader(value[0].raw);
            case 2:
              res = _context.v;
              fileUrl.value = window.location.protocol + res;
              pushButtonLoading.value = false; // 退出loading状态
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              // console.log('文件上传失败');
              pushButtonLoading.value = false; // 退出loading状态
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function handleUpload(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var handleUploader = function handleUploader(file) {
      return uploadObs({
        bucketName: env_name ? "zxhj-course-".concat(env_name) : 'course-prod',
        file: file,
        fileType: getFileType(file.name),
        // 文件类型 (1文本/文档, 2图像/图片, 3视频, 4音频, 5压缩包, 6其他)
        userId: userInfo.id,
        userName: userInfo.name,
        institutionId: userInfo.institutionId,
        institutionName: userInfo.institutionName,
        appCode: 'inspirationCentre',
        appName: '创作中心',
        pageName: 'repository',
        btnName: '上传申请修改习题'
      });
    };
    var handleConfirm = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var fileName, params;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              pushButtonLoading.value = true; // 进入loading状态
              fileName = fileData.value[0] && fileData.value[0].name ? fileData.value[0].name : '';
              params = {
                applyContent: applyContent.value,
                fileUrl: fileUrl.value,
                fileName: fileName || '',
                fileSize: fileData.value[0] ? fileData.value[0].size : ''
              };
              applyEditExercise(props === null || props === void 0 ? void 0 : props.exerciseId, params).then(function (res) {
                if (res.data.code === 0) {
                  MessagePlugin.success('申请成功！');
                  emit('reload');
                  handleClose();
                }
              }).finally(function () {
                pushButtonLoading.value = false;
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function handleConfirm() {
        return _ref3.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_upload = _resolveComponent("t-upload");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        class: "my-dialog",
        visible: props.visible,
        header: "申请修改",
        width: "1000px",
        onClose: handleClose
      }, {
        footer: _withCtx(function () {
          return [_createVNode(_component_t_button, {
            theme: "default",
            onClick: handleClose
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode("取消", -1)]));
            }),
            _: 1
          }), _createVNode(_component_t_button, {
            onClick: handleConfirm,
            loading: pushButtonLoading.value
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode("发起", -1)]));
            }),
            _: 1
          }, 8, ["loading"])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("p", {
            class: "label-title"
          }, "文件", -1)), _createElementVNode("div", null, [_createVNode(_component_t_upload, {
            tips: "",
            accept: _unref(ACCEPT_TYPE),
            "trigger-button-props": {
              theme: 'primary',
              variant: 'base'
            },
            autoUpload: false,
            files: fileData.value,
            "abridge-name": [20, 0],
            onChange: handleUpload,
            onRemove: removeFile
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_button, {
                theme: "primary"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("img", {
                    src: require('@/assets/upload.svg'),
                    alt: ""
                  }, null, 8, _hoisted_2), _cache[1] || (_cache[1] = _createTextVNode(" 上传文件 ", -1))];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["accept", "files"])])]), _createElementVNode("div", _hoisted_3, [_cache[3] || (_cache[3] = _createElementVNode("p", {
            class: "label-title"
          }, "备注", -1)), _createVNode(_unref(inlineEditor), {
            value: applyContent.value,
            "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
              return applyContent.value = $event;
            }),
            minHeight: 188
          }, null, 8, ["value"])])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};